/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentTsPay {
    constructor(cscom) {
        if (!(this instanceof CurrentTsPay)) {
            return new CurrentTsPay(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/tspay/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/tspay/list', null, data);
    }

}
